import './Nav.svelte.css.proxy.js';
/* src/components/navigation/Nav.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Wrap from "../slot/Wrap.svelte.js";
import { basePath, menu } from "../../_config/navigation.js";
import { folded } from "./index.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

// (23:6) {#each menu as m}
function create_each_block(ctx) {
	let li;
	let a;
	let t0_value = /*m*/ ctx[5].name + "";
	let t0;
	let a_href_value;
	let t1;

	return {
		c() {
			li = element("li");
			a = element("a");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			a = claim_element(li_nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			t0 = claim_text(a_nodes, t0_value);
			a_nodes.forEach(detach);
			t1 = claim_space(li_nodes);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", a_href_value = basePath + /*m*/ ctx[5].href);
			attr(a, "class", "svelte-okus12");
			toggle_class(a, "selected", /*m*/ ctx[5].segment === /*segment*/ ctx[0]);
			attr(li, "class", "svelte-okus12");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, a);
			append(a, t0);
			append(li, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*menu, segment*/ 1) {
				toggle_class(a, "selected", /*m*/ ctx[5].segment === /*segment*/ ctx[0]);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (21:2) <Wrap fullOnMobile>
function create_default_slot(ctx) {
	let ul;
	let each_value = menu;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			ul = claim_element(nodes, "UL", { class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(ul, "class", "svelte-okus12");
		},
		m(target, anchor) {
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}
		},
		p(ctx, dirty) {
			if (dirty & /*basePath, menu, segment*/ 1) {
				each_value = menu;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
		}
	};
}

function create_fragment(ctx) {
	let nav;
	let wrap;
	let t0;
	let div;
	let span0;
	let t1;
	let span1;
	let t2;
	let span2;
	let current;
	let mounted;
	let dispose;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			nav = element("nav");
			create_component(wrap.$$.fragment);
			t0 = space();
			div = element("div");
			span0 = element("span");
			t1 = space();
			span1 = element("span");
			t2 = space();
			span2 = element("span");
			this.h();
		},
		l(nodes) {
			nav = claim_element(nodes, "NAV", { class: true });
			var nav_nodes = children(nav);
			claim_component(wrap.$$.fragment, nav_nodes);
			nav_nodes.forEach(detach);
			t0 = claim_space(nodes);
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			span0 = claim_element(div_nodes, "SPAN", { class: true });
			children(span0).forEach(detach);
			t1 = claim_space(div_nodes);
			span1 = claim_element(div_nodes, "SPAN", { class: true });
			children(span1).forEach(detach);
			t2 = claim_space(div_nodes);
			span2 = claim_element(div_nodes, "SPAN", { class: true });
			children(span2).forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(nav, "class", "svelte-okus12");
			toggle_class(nav, "expanded", !/*$folded*/ ctx[1]);
			attr(span0, "class", "svelte-okus12");
			attr(span1, "class", "svelte-okus12");
			attr(span2, "class", "svelte-okus12");
			attr(div, "class", "expand svelte-okus12");
			toggle_class(div, "expanded", !/*$folded*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, nav, anchor);
			mount_component(wrap, nav, null);
			insert(target, t0, anchor);
			insert(target, div, anchor);
			append(div, span0);
			append(div, t1);
			append(div, span1);
			append(div, t2);
			append(div, span2);
			current = true;

			if (!mounted) {
				dispose = [
					listen(nav, "click", /*fold*/ ctx[3]),
					listen(div, "click", /*toggle*/ ctx[2])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			const wrap_changes = {};

			if (dirty & /*$$scope, segment*/ 257) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);

			if (dirty & /*$folded*/ 2) {
				toggle_class(nav, "expanded", !/*$folded*/ ctx[1]);
			}

			if (dirty & /*$folded*/ 2) {
				toggle_class(div, "expanded", !/*$folded*/ ctx[1]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(nav);
			destroy_component(wrap);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $folded;
	component_subscribe($$self, folded, $$value => $$invalidate(1, $folded = $$value));
	let { segment } = $$props;
	folded.set(true);

	function link(href) {
		return () => {
			folded.set(true);
			location.href = basePath + href;
		};
	}

	function toggle() {
		folded.set(!$folded);
	}

	function fold() {
		folded.set(true);
	}

	$$self.$$set = $$props => {
		if ("segment" in $$props) $$invalidate(0, segment = $$props.segment);
	};

	return [segment, $folded, toggle, fold];
}

class Nav extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { segment: 0 });
	}
}

export default Nav;
//# sourceMappingURL=Nav.svelte.js.map
